import RestClientService from 'Services/RestClientService';

class TicketApiService {
  static async getAll() {
    return RestClientService.Get('/api/tickets');
  }

  static async getById(id) {
    return RestClientService.Get(`/api/tickets/${id}`);
  }

  static async create(data) {
    return RestClientService.Post('/api/tickets', data);
  }

  static async update(id, data) {
    return RestClientService.Patch(`/api/tickets/${id}`, data);
  }

  static async delete(id) {
    return RestClientService.Delete(`/api/tickets/${id}`);
  }

  static async getByStatus(status) {
    return RestClientService.Get(`/api/tickets/status/${status}`);
  }

  static async updateStatus(id, status) {
    return RestClientService.Patch(`/api/tickets/${id}/status`, { status });
  }

  static async getAgGridData(endpoint, requestParams) {
    return RestClientService.Post(endpoint, requestParams);
  }
}

export default TicketApiService;
